import React from 'react';
import { Link } from 'react-router-dom';
import DealingIn from '../components/DealingIn';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const ServicesPage = () => {
  return (
    <div className="pt-20">
      {/* Hero Section with Background */}
      <section className="relative min-h-[60vh] flex items-center justify-center bg-white">
        {/* Background Image */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2000"
            alt="Our Services"
            className="w-full h-full object-cover animate-ken-burns"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-fade-in-up" style={{ fontFamily: "'Playfair Display', serif" }}>
              Our Services
            </h1>
            <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in">
              <div className="h-1 w-20 bg-[#B8944A] rounded"></div>
              <div className="w-3 h-3 bg-[#B8944A] rounded-full"></div>
              <div className="h-1 w-20 bg-[#B8944A] rounded"></div>
            </div>
            <p className="text-xl text-white/90 leading-relaxed animate-fade-in-up animation-delay-200">
              Comprehensive Real Estate Solutions Tailored For You
            </p>
          </div>
        </div>
      </section>

      {/* OUR CONSULTING SERVICES Component */}
      <DealingIn />

      {/* Why Choose Us */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Why Choose Us?</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-[#B8944A] font-bold text-xl">01</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Market Knowledge</h3>
                  <p className="text-gray-600">Deep understanding of local and national real estate markets ensures informed decisions.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-[#B8944A] font-bold text-xl">02</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Personalized Service</h3>
                  <p className="text-gray-600">Tailored solutions that align with your unique goals and requirements.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-[#B8944A] font-bold text-xl">03</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Proven Track Record</h3>
                  <p className="text-gray-600">Over 500 successful transactions and countless satisfied clients speak to our excellence.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#B8944A]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-[#B8944A] font-bold text-xl">04</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">End-to-End Support</h3>
                  <p className="text-gray-600">Comprehensive assistance from property search to final closing and beyond.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gradient-to-r from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Get Started?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Contact us today to discuss how we can help you achieve your real estate goals
          </p>
          <Link to="/contact">
            <Button 
              size="lg" 
              className="bg-[#B8944A] hover:bg-[#A07D3A] text-white px-8 py-6 text-base font-medium rounded-full transition-all duration-300"
            >
              Schedule a Consultation
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;